import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export const getPlans = async () => {
  return apiInstance.get(ApiRoutes.Plan);
};

export const updatePlan = async (priceId: string, renew?: boolean) => {
  return apiInstance.put(`${ApiRoutes.Plan}/update`, {
    priceId,
    ...(renew !== undefined && { renew }),
  });
};

export const createIntent = async () => {
  return apiInstance.post(`${ApiRoutes.Plan}/intent`);
};

export const getInvoices = async (data: {
  subId: string;
  orderBy?: 'amount' | 'status' | 'description' | 'payment_method' | 'date';
  orderDirection?: 'asc' | 'desc';
  limit?: number;
  startingAfter?: string;
}) => {
  return apiInstance.post(`${ApiRoutes.Plan}/invoices`, { ...data });
};

export const updatePlanAdmin = async (
  planId: string,
  planData: {
    type: string;
    reviewRequestLimit: number;
    seatLimit: number;
    price: number;
    priceId: string;
    currency: string;
    interval: string;
    isActive: boolean;
    features: string[];
  }
) => {
  return apiInstance.put(`${ApiRoutes.Plan}/${planId}`, planData);
};

export const setDefaultPaymentMethod = async (paymentMethodId: string) => {
  return apiInstance.put(`${ApiRoutes.Plan}/default-payment-method`, {
    paymentMethodId,
  });
};

export const deletePlan = async (planId: string) => {
  return apiInstance.delete(`${ApiRoutes.Plan}/${planId}`);
};
